module.exports = __webpack_public_path__ + "static/feature-24mm-glazing-2b36a297815f77a00d439e16eba2f1bf.png";